import React, { MouseEvent, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from './app/hooks'

import { API_PATH } from './constants';

import { isEmpty } from 'lodash';
import Semaphore from 'semaphore-async-await';
import { http } from './utils/config';

import { fetchScenarios, fetchTagScenarios, fetchImages } from './features/scenarioSlice'
import { fetchGames, selectGamesSlice, deleteGame, leaveGame } from './features/player/gameSlice'
import { hostGame, joinGame } from './features/player/gameSlice'
import { fetchGameStatus } from './features/player/gameStatusSlice'

import { IGame, IGameStatus, IScenario, IPlayer, IScenarioImageSet, IImagePayloadItem } from './interfaces';
import { Game, Scenario } from './Classes1';

import Modal from 'react-modal';
import PasswordChecklist from "react-password-checklist"
import { WithContext as ReactTags } from 'react-tag-input';

import ScenarioDescription from './components/player/ScenarioDescription'
import GameLobby from './components/player/GameLobby'
import MainGame from './components/player/MainGame';
import PlayerHeader from './components/player/PlayerHeader';

import './App.css';
import type {RootState} from "./store";
import {fetchUser} from "./features/user/userSlice";
import {parseJwt} from "./helpers/helperFunctions";

const KeyCodes = {
    comma: 188,
    enter: 13
  };

const delimiters = [KeyCodes.comma, KeyCodes.enter];

const customStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '640px',
      transform: 'translate(-50%, -50%)',
    }
};

const customSmallStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '480px',
      transform: 'translate(-50%, -50%)',
    }
};

Modal.setAppElement('#root');

export type PlayerHomeProps = {
    intervalHandler: (command: string, gameId: string, inGame: boolean) => void
};

const isImgSrcCloud = process.env.REACT_APP_IMAGE_SRC === 'cloud';
type LocalImageSetMap = {[key: string]: string[]};
type ScenarioImageSetMap = {[key: string]: IScenarioImageSet };

const PlayerHome: React.FC<PlayerHomeProps> = ({ intervalHandler }) => {

    const [modalIsOpen, setIsOpen] = useState<boolean>(false);
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState<boolean>(false);
    const [leaveGameModalIsOpen, setLeaveGameModalIsOpen] = useState<boolean>(false);
    const [rejectModalIsOpen, setRejectModalIsOpen] = useState<boolean>(false);
    const [gameStartedModalIsOpen, setGameStartedModalIsOpen] = useState<boolean>(false);
    const [hostingModalIsOpen, setHostingModalIsOpen] = useState<boolean>(false);
    const [failedHostModalIsOpen, setFailedHostModalIsOpen] = useState<boolean>(false);
    const [alreadyHostingModalIsOpen, setAlreadyHostingModalIsOpen] = useState<boolean>(false);
    const [privateGameModalIsOpen, setPrivateGameModalIsOpen] = useState<boolean>(false);
    const [alreadyHostingGame, setAlreadyHostingGame] = useState<string>('');
    const [isAlreadyHostingGame, setIsAlreadyHostingGame] = useState<boolean>(false);
    const [gamePassword, setGamePassword] = useState<string>('');
    const [passwordError, setPasswordError] = useState<string>('');
    const [generatedGamePassword, setGeneratedGamePassword] = useState<string>('');
    const [showHostPassword, setShowHostPassword] = useState<string>('hide');
    const [showHostLoading, setShowHostLoading] = useState<boolean>(false);

    const [allScenariosSelected, setAllScenariosSelected] = useState<string>('selected')
    const [myScenariosSelected, setMyScenariosSelected] = useState<string>('')
    const [featuredSelected, setFeaturedSelected] = useState<string>('')
    const [liveScenariosSelected, setLiveScenariosSelected] = useState<string>('')

    const [gridSelected, setGridSelected] = useState<string>('selected')
    const [listSelected, setListSelected] = useState<string>('')

    const [layoutType, setLayoutType] = useState<string>('grid')
    const [showFeature, setShowFeature] = useState<string>('featured')

    const [playerTagOpen, setPlayerTagOpen] = useState<string>('')
    const [topicTags, setTopicTags] = useState<any[]>([])
    const [locationTags, setLocationTags] = useState<any[]>([])
    const [detailsTags, setDetailsTags] = useState<any[]>([])

    const [showGameLobby, setShowGameLobby] = useState<string>('')
    const [openSearch, setOpenSearch] = useState<string>('')
    const [gameScenario, setGameScenario] = useState<IScenario>(new Scenario({}))
    const [showGame, setShowGame] = useState<string>('')
    const [currentGame, setCurrentGame] = useState<IGame>(new Game(''))
    const [currentGameId, setCurrentGameId] = useState<string>('')
    const [isHosting, setIsHosting] = useState<boolean>(false)
    const [showScenarioPage, setShowScenarioPage] = useState<string>('')
    const [showScenarioHideHome, setShowScenarioHideHome] = useState<string>('')
    const [gameID, setGameID] = useState<any>('')
    const [scenarioID, setScenarioID] = useState<any>('')
    const [featuredSearchResults, setFeaturedSearchResults] = useState<any[]>([])
    const [mySearchResults, setMySearchResults] = useState<any[]>([])
    const [allSearchResults, setAllSearchResults] = useState<any[]>([])
    const [gameScenarios, setGameScenarios] = useState<IScenario[]>([])
    const [searchVal, setSearchVal] = useState<string>('')
    const [scenarioLoader, setScenarioLoader] = useState<string>('hide')
    const [gameToDelete, setGameToDelete] = useState<string>('')
    const [gameIdToDelete, setGameIdToDelete] = useState<string>('')
    const [gameToLeave, setGameToLeave] = useState<string>('')
    const [gameIdToLeave, setGameIdToLeave] = useState<string>('')
    const [errorModalIsOpen, setErrorModalIsOpen] = useState<boolean>(false);
    const [errorText, setErrorText] = useState<string>('');
    const [scenarioImages, setScenarioImages] = useState<ScenarioImageSetMap>({});
    const [gameName, setGameName] = useState<string>('')
    const [password, setPassword] = useState<string>("")
    const [passwordGood, setPasswordGood] = useState<boolean>(true)
    const [gameStartedError, setGameStartedError] = useState<string>('')
    const [gameStartedErrorText, setGameStartedErrorText] = useState<string>('')

    const [joinGameLoading, setJoinGameLoading] = useState<boolean>(false)
    const [joinGameLocalLoading, setJoinGameLocalLoading] = useState<boolean>(false)
    const [deleteGameLoading, setDeleteGameLoading] = useState<boolean>(false)
    const [leaveGameLoading, setLeaveGameLoading] = useState<boolean>(false)

    const { accessToken } = useAppSelector((state: RootState) => state.auth)
    const [userAdmin, setUserAdmin] = useState<boolean>(false)
    
    const dispatch: any = useAppDispatch();
    const navigate = useNavigate();

    let games: IGameStatus[] = useAppSelector(selectGamesSlice);

    const fetchScenarioImages = (scenarioIds: string[], localImages: LocalImageSetMap = {}) => {
        if (scenarioIds.length < 1) { return; }

        // Set up initial images while we wait for loading (or not if we're not using cloud images).
        scenarioIds.forEach((sid) => {
            setScenarioImages((prevState) => {
                const newState = { ...prevState };
                newState[sid] = {
                    id: sid,
                    images: isImgSrcCloud
                        ? ['img/loading-392x202.gif']
                        : localImages[sid] || ['img/scenario1.png'],
                };
                return newState;
            });
        });

        if (!isImgSrcCloud) { return } // If we're not using cloud images, we're done.

        // We're using cloud images, so we need to use the API to get signed image URLs.
        // Using a semaphore to avoid saturating the server with image list requests.
        const queue = new Semaphore(4);
        const imgFetches = scenarioIds.map(async (sid: string) => {
            await queue.wait();
            const fetchResp = await dispatch(fetchImages(sid));
            queue.signal();
            const images = (fetchResp.meta.requestStatus !== 'fulfilled' || !fetchResp.payload || fetchResp.payload.length === 0)
                ? ['img/scenario1.png'] // Error or no images, show the default image.
                : fetchResp.payload.map((img: IImagePayloadItem) => img.url) // Grab all the urls
            setScenarioImages((prevState) => {
                const newState = { ...prevState };
                newState[sid] = { id: sid, images };
                return newState;
            });
        });
        Promise.all(imgFetches);
    }

    useEffect(() => {
        const toFetch = games.filter((game) => !scenarioImages[game.scenarioId]);
        const uniqIds = Array.from(new Set<string>(toFetch.map(({scenarioId}:any) => scenarioId as string)));
        fetchScenarioImages(uniqIds);
    }, [games]) // eslint-disable-line react-hooks/exhaustive-deps
    // NOTE: We are disabling because we don't a recursive loop on scenarioImages

    useEffect(() => {
        async function asyncCall() {
            await dispatch(fetchGames())
            let searchRes: any = await dispatch(fetchScenarios())
            if (searchRes && searchRes.payload.myScenarios !== undefined) {
                const { featured, myScenarios, allScenarios } = searchRes.payload;
                setFeaturedSearchResults(featured);
                setMySearchResults(myScenarios);
                setAllSearchResults(allScenarios);
                const everything : IScenario[] = featured.concat(myScenarios).concat(allScenarios);
                setGameScenarios(everything)

                const localImages = isImgSrcCloud ? everything.reduce<LocalImageSetMap>((liMap, s: IScenario) => {
                    liMap[s.id] = s.localImages;
                    return liMap;
                }, {}) : {};

                const uniqIds = Array.from(new Set<string>(everything.map(({id}:any) => id as string)));
                fetchScenarioImages(uniqIds, localImages);
            }
        }

        asyncCall();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isEmpty(password)) {
            setPasswordGood(true)
        }
    }, [password])

    const gameScenariosRef = useRef<any[]>([])
    useEffect(() => {
        gameScenariosRef.current = gameScenarios
    });

    const gamesRef = useRef<any[]>([])
    useEffect(() => {
        gamesRef.current = games
    });

    const currGameRef = useRef<any>()
    useEffect(() => {
        currGameRef.current = currentGame
    });

    useEffect(() => {
        async function asyncCall() {
            if (accessToken) {
                let parsedJWT = parseJwt(accessToken)
                let user = await dispatch(fetchUser(parsedJWT.id))
                setUserAdmin(user.payload.admin)
            }
        }
        asyncCall();
    }, [dispatch, accessToken]);

    const user = useAppSelector((state) => state.auth.userId)
    const openModal = () => {
        setIsOpen(true);
    }

    const setGameScenarioById = (scenarioId: string | undefined) => {
        if (scenarioId !== undefined) {
            for (let i = 0; i<gameScenarios.length; i++) {
                if (gameScenarios[i].id === scenarioId) {
                    setGameScenario(gameScenarios[i])
                }
            }
        }
    }

    const clickScenario = (ev: MouseEvent) => {
        const target = ev.currentTarget as HTMLElement;
        if (target) {
            setGameScenarioById(target.dataset.scenarioid)
            setShowScenarioHideHome('hide-home')
            setShowScenarioPage('show')
        }
    }

    const selectSubMenu = (ev: MouseEvent) => {
        if (!(ev.currentTarget instanceof HTMLElement)) {
            return;
        }
        switch(ev.currentTarget.dataset.item) {
            case 'featured':
                setFeaturedSelected('selected')
                setAllScenariosSelected('')
                setMyScenariosSelected('')
                setLiveScenariosSelected('')
                setShowFeature('featured')
              break;
            case 'allscenarios':
                setFeaturedSelected('')
                setAllScenariosSelected('selected')
                setMyScenariosSelected('')
                setLiveScenariosSelected('')
                setShowFeature('featured')
              break;
            case 'myscenarios':
                setFeaturedSelected('')
                setAllScenariosSelected('')
                setMyScenariosSelected('selected')
                setLiveScenariosSelected('')
                setShowFeature('featured')
              break;
            case 'livescenarios':
                setFeaturedSelected('')
                setAllScenariosSelected('')
                setMyScenariosSelected('')
                setLiveScenariosSelected('selected')
                setShowFeature('featured')
              break;
            default:
              break;
          }
    }

    const selectLayout = (ev: MouseEvent) => {
        if (!(ev.currentTarget instanceof HTMLElement)) {
            return;
        }
        switch(ev.currentTarget.dataset.item) {
            case 'grid':
                setGridSelected('selected')
                setListSelected('')
                setLayoutType('grid')
              break;
            case 'list':
                setGridSelected('')
                setListSelected('selected')
                setLayoutType('list')
              break;
            default:
              break;
          }
    }

    const filterSearch = (results: any) => {
        // filter all scenarios - published = true
        // filter my scenarios - ownerId = user + sharedWith = user
        // filter featured scenarios - published = true, featured = true
        let allScenarios: IScenario[] = results.filter((scen: IScenario) => scen.published);
        let myScenarios: IScenario[] = results.filter((scen: IScenario) => scen.owner === user || scen.sharedWith.includes(user!));
        let featuredScenarios: IScenario[] = results.filter((scen: IScenario) => scen.published && scen.featured);

        setAllSearchResults(allScenarios)
        setMySearchResults(myScenarios)
        setFeaturedSearchResults(featuredScenarios)

    }

    const handleTopicsDelete = async (i: number) => {
        setScenarioLoader('show')
        setTopicTags(topicTags.filter((tag, index) => index !== i))
        let newTags: string[] = [];
        newTags = topicTags.filter((tag, index) => index !== i)
        
        let searchRes: any = await dispatch(fetchTagScenarios({locationTags: locationTags.map((tag: any) => tag.text), topicTags: newTags, detailsTags: detailsTags.map((tag: any) => tag.text), searchString: ''}))
        filterSearch(searchRes.payload)
        setScenarioLoader('hide')
    };

    const handleTopicsAddition = async (tag: any) => {
        setScenarioLoader('show')
        let tempTags: any = JSON.parse(JSON.stringify(topicTags));
        tempTags.push(tag)
        setTopicTags([...topicTags, tag]);
        let newTags: string[] = [];
        newTags = tempTags.map((tag: any) => tag.text)
        let searchRes: any = await dispatch(fetchTagScenarios({locationTags: locationTags.map((tag: any) => tag.text), topicTags: newTags, detailsTags: detailsTags.map((tag: any) => tag.text), searchString: ''}))
        filterSearch(searchRes.payload)
        setScenarioLoader('hide')
    };

    const handleTopicsDrag = (tag: any, currPos: any, newPos: any) => {
        const newTags = topicTags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setTopicTags(newTags);
    };

    const handleLocationsDelete = async (i: number) => {
        setScenarioLoader('show')
        setLocationTags(locationTags.filter((tag, index) => index !== i))
        let newTags: string[] = [];
        newTags = locationTags.filter((tag, index) => index !== i)
        let searchRes: any = await dispatch(fetchTagScenarios({locationTags: newTags, topicTags: topicTags.map((tag: any) => tag.text), detailsTags: detailsTags.map((tag: any) => tag.text), searchString: ''}))
        filterSearch(searchRes.payload)
        setScenarioLoader('hide')
    };

    const handleLocationsAddition = async (tag: any) => {
        setScenarioLoader('show')
        let tempTags: any = JSON.parse(JSON.stringify(locationTags));
        tempTags.push(tag)
        setLocationTags([...locationTags, tag]);
        let newTags: string[] = [];
        newTags = tempTags.map((tag: any) => tag.text)
        let searchRes: any = await dispatch(fetchTagScenarios({locationTags: newTags, topicTags: topicTags.map((tag: any) => tag.text), detailsTags: detailsTags.map((tag: any) => tag.text), searchString: ''}))
        filterSearch(searchRes.payload)
        setScenarioLoader('hide')
    };

    const handleLocationsDrag = (tag: any, currPos: any, newPos: any) => {
        const newTags = locationTags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setLocationTags(newTags);
    };

    const handleDetailsDelete = async (i: number) => {
        setScenarioLoader('show')
        setDetailsTags(detailsTags.filter((tag, index) => index !== i))
        let newTags: string[] = [];
        newTags = detailsTags.filter((tag, index) => index !== i)
        let searchRes: any = await dispatch(fetchTagScenarios({locationTags: locationTags.map((tag: any) => tag.text), topicTags: topicTags.map((tag: any) => tag.text), detailsTags: newTags, searchString: ''}))
        filterSearch(searchRes.payload)
        setScenarioLoader('hide')
    };

    const handleDetailsAddition = async (tag: any) => {
        setScenarioLoader('show')
        let tempTags: any = JSON.parse(JSON.stringify(detailsTags));
        tempTags.push(tag)
        setDetailsTags([...detailsTags, tag]);
        let newTags: string[] = [];
        newTags = tempTags.map((tag: any) => tag.text)
        let searchRes: any = await dispatch(fetchTagScenarios({locationTags: locationTags.map((tag: any) => tag.text), topicTags: topicTags.map((tag: any) => tag.text), detailsTags: newTags, searchString: ''}))
        filterSearch(searchRes.payload)
        setScenarioLoader('hide')
    };

    const handleDetailsDrag = (tag: any, currPos: any, newPos: any) => {
        const newTags = detailsTags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setDetailsTags(newTags);
    };

    const clickPlayerTag = (ev: MouseEvent) => {
        playerTagOpen === '' ? setPlayerTagOpen('player-tag-open') : setPlayerTagOpen('');
    }

    const clickPlayerSearch = (ev: MouseEvent) => {
        openSearch === '' ? setOpenSearch('open-search') : setOpenSearch('');
    }

    const toggleScenarioPage = async (ev: MouseEvent) => {
        if (!(ev.currentTarget instanceof HTMLElement) || joinGameLoading) {
            return;
        }

        const target = ev.currentTarget as HTMLElement;

        setPasswordError('')
        setGameStartedError('')

        let gameStatusResponse;
        if (target && target.dataset.gameid !== undefined) {
            setGameID(target.dataset.gameid)
            setScenarioID(target.dataset.scenarioid)
            gameStatusResponse = await dispatch(fetchGameStatus(target.dataset.gameid))
        }

        if (gameStatusResponse !== undefined && gameStatusResponse.payload[0].isPrivate) {
            openModal();
        } else {
            if (!target) {
                return
            }

            let currGame: IGame = new Game('');
            let currScenario: IScenario = new Scenario('');

            if (target.dataset.type === 'host') {
                let scen = gameScenarios.find((s) => s.id === target.dataset.scenarioid);
                if (!scen) {
                    const scenResp = await http.get(`${API_PATH}/scenario/${target.dataset.scenarioid}`);
                    if (Math.floor(scenResp.status / 100) === 2) {
                        scen = scenResp.data;
                    }
                }
                if (!scen) {
                    console.log('Unexpected problem finding scenario');
                    return;
                }

                setGameScenario(scen);
                currScenario = scen;

                let alreadyHosting: boolean = false;

                for (let i = 0; i<gamesRef.current.length; i++) {
                    if (gamesRef.current[i].gameId === target.dataset.gameid) {
                        currGame = JSON.parse(JSON.stringify(gamesRef.current[i]));
                        setCurrentGameId(gamesRef.current[i].gameId)
                        setCurrentGame(currGame)
                    }
                }

                if (!alreadyHosting) {
                    let isHostingGame: boolean = false;
                    for (let i = 0; i<games.length; i++) {
                        if (games[i].host === user && !games[i].completed) {
                            isHostingGame = true
                            setGameToDelete(games[i].name)
                            setGameIdToDelete(games[i].gameId)
                            setAlreadyHostingGame(games[i].name);
                        }
                    }

                    if (!isHostingGame) {
                        setIsAlreadyHostingGame(false)
                    } else {
                        setIsAlreadyHostingGame(true)
                    }

                    setGameName(currScenario.name + ' Game')
                    openHostingModal()
                } else if (currGame.started) {
                    intervalHandler("start", target.dataset.gameid!, true)
                    setShowGame('show-game')
                } else {
                    intervalHandler("start", target.dataset.gameid!, false)
                    setShowGameLobby('show-page')
                    calcGameLobbyHeight()
                }

            } else if (target.dataset.type === 'join') {
                let alreadyJoined: boolean = false;
                let scen = gameScenarios.find((s) => s.id === target.dataset.scenarioid);
                if (!scen) {
                    try {
                        const scenResp = await http.get(`${API_PATH}/scenario/${target.dataset.scenarioid}`);
                        if (Math.floor(scenResp.status / 100) === 2) {
                            scen = scenResp.data;
                        }
                    } catch (e) {
                        console.log('Error retrieving scenario info.')
                        return
                    }
                }

                if (!scen) {
                    console.log('Error retrieving scenario info.')
                    return
                }

                setGameScenario(scen);

                for (let i = 0; i<gameStatusResponse.payload[0].players.length; i++) {
                    if (gameStatusResponse.payload[0].players[i].userID === user) {
                        alreadyJoined = true;
                        if (gameStatusResponse.payload[0].started) {
                            intervalHandler("start", target.dataset.gameid!, true)
                            setShowGame('show-game')
                        } else {
                            intervalHandler("start", target.dataset.gameid!, false)
                            setShowGameLobby('show-page')
                            calcGameLobbyHeight()
                        }
                    }
                }

                for (let i = 0; i<gamesRef.current.length; i++) {
                    if (gamesRef.current[i].gameId === target.dataset.gameid) {
                        currGame = JSON.parse(JSON.stringify(gamesRef.current[i]));
                        setCurrentGameId(gamesRef.current[i].gameId)
                        setCurrentGame(currGame)
                    }
                }

                if (currGame.host === user) {
                    setIsHosting(true)
                } else {
                    setIsHosting(false)
                }

                await dispatch(fetchGameStatus(currGame.gameId))
                await dispatch(fetchGames())

                if (!alreadyJoined) {
                    setJoinGameLoading(true)
                    let joinGameObj: any = {};
                    joinGameObj.id = target.dataset.gameid;
                    joinGameObj.password = gamePassword;

                    let joinGameResponse: any = await dispatch(joinGame(joinGameObj))
                    setJoinGameLoading(false)
                    await dispatch(fetchGameStatus(joinGameResponse.payload.gameId))
                    await dispatch(fetchGames())

                    if (joinGameResponse.error !== undefined) {
                        openGameStartedModal()
                        setGameStartedErrorText(joinGameResponse.payload)
                    } else {
                        intervalHandler("start", joinGameResponse.payload.gameId, false)
                        setShowGameLobby('show-page')
                        calcGameLobbyHeight()
                    }
                }
            }
        }
    }

    const joinGameLocal = async (ev: MouseEvent) => {
        if (joinGameLocalLoading) {
            return;
        }
        const target = ev.currentTarget as HTMLElement;
        
        let currGame: IGame = new Game('');
        for (let i = 0; i<games.length; i++) {
            if (games[i].gameId === target.dataset.gameid) {
                currGame = JSON.parse(JSON.stringify(games[i]));
                setCurrentGameId(games[i].gameId)
                setCurrentGame(currGame)
            }
        }

        for (let i = 0; i<gameScenarios.length; i++) {
            if (gameScenarios[i].id === target.dataset.scenarioid) {
                setGameScenario(gameScenarios[i])
            }
        }
        
        if (target) {
                let gameStatusResponse = await dispatch(fetchGameStatus(target.dataset.gameid))
                let alreadyJoined: boolean = false;
                let currGame: IGame = new Game('');

                for (let i = 0; i<games.length; i++) {
                    if (games[i].gameId === target.dataset.gameid) {
                        currGame = JSON.parse(JSON.stringify(games[i]));
                        setCurrentGameId(games[i].gameId)
                    }
                }

                for (let i = 0; i<gameScenarios.length; i++) {
                    if (gameScenarios[i].id === target.dataset.scenarioid) {
                        setGameScenario(gameScenarios[i])
                    }
                }

                if (currGame.host === user) {
                    setIsHosting(true)
                } else {
                    setIsHosting(false)
                }

                for (let i = 0; i<gameStatusResponse.payload[0].players.length; i++) {
                    if (gameStatusResponse.payload[0].players[i].userID === user) {
                        alreadyJoined = true;
                    }
                }

                if (!alreadyJoined) {
                    if (currGame.password !== gamePassword) {
                        setPasswordError('show')
                    } else {
                        setJoinGameLocalLoading(true)
                        let joinGameObj: any = {};
                        joinGameObj.id = target.dataset.gameid;
                        joinGameObj.password = gamePassword;

                        let joinGameResponse: any = await dispatch(joinGame(joinGameObj))
                        await dispatch(fetchGameStatus(joinGameResponse.payload.gameId))
                        await dispatch(fetchGames())

                        if (joinGameResponse.error !== undefined) {
                            setGameStartedError('show')
                            setGameStartedErrorText(joinGameResponse.payload)
                            setJoinGameLocalLoading(false)
                        } else {
                            closeModal()
                            setShowGameLobby('show-page')
                            calcGameLobbyHeight()
                            setJoinGameLocalLoading(false)
                        }
                    }
                } else {
                    if (currGame.password !== gamePassword) {
                        setPasswordError('show')
                    } else {
                        if (gameStatusResponse.payload[0].started) {
                            closeModal()
                            setShowGame('show-game')
                        } else {
                            closeModal()
                            setShowGameLobby('show-page')
                            calcGameLobbyHeight()
                        }
                    }
                }
        }
    }

    const makeGamePrivate = async (ev: MouseEvent) => {
        const target = ev.currentTarget as HTMLElement;
        
        if (target) {
            // ask server if player can host game
            let hostGameObj: any = {};
            hostGameObj.id = '';
            hostGameObj.password = gamePassword;
            
            setShowHostPassword('show')
            setTimeout(async () => {
                setGeneratedGamePassword('tinley568')
            }, 3000)
            
        }
    }

    const goToHostedGame = async () => {
        if (showHostLoading) {
            return;
        }
        setShowHostLoading(true);
        let hostGameObj: any = {};
        hostGameObj.id = gameScenario.id;
        hostGameObj.gameName = gameName;
        hostGameObj.password = password;

        await dispatch(fetchGames())

        let isHostingGame: boolean = false;
        let hostedGameName: string = '';
        for (let i = 0; i<games.length; i++) {
            if (games[i].host === user && !games[i].completed) {
                isHostingGame = true
                hostedGameName = games[i].name;
            }
        }

        if (!isHostingGame) {
            let hostGameResponse: any = await dispatch(hostGame(hostGameObj))
            await dispatch(fetchGames())
            await dispatch(fetchGameStatus(hostGameResponse.payload.gameId))

            let currGame: IGame = new Game('');

            for (let i = 0; i<gamesRef.current.length; i++) {
                if (gamesRef.current[i].gameId === hostGameResponse.payload.gameId) {
                    currGame = JSON.parse(JSON.stringify(gamesRef.current[i]));
                }
            }

            setCurrentGame(currGame)
            setCurrentGameId(currGame.gameId)
            setIsHosting(true);
            setShowScenarioHideHome('')
            setShowScenarioPage('');
            closeHostingModal()
            setPassword('')
            intervalHandler("start", currGame.gameId, false)
            setShowGameLobby('show-page')
            calcGameLobbyHeight()
            setShowHostLoading(false);
        } else {
            closePrivateGameModal();
            setAlreadyHostingGame(hostedGameName);
            openAlreadyHostingModal();
            setShowHostLoading(false);
        }
    }

    const doSearch = async (ev: React.ChangeEvent<HTMLInputElement>) => {
        const target = ev.currentTarget as HTMLInputElement;
        
        if (target) {
            setSearchVal(target.value)
            if (target.value.length > 2 || target.value.length === 0) {
                let searchRes: any = await dispatch(fetchTagScenarios({locationTags: locationTags, topicTags: topicTags, detailsTags: detailsTags, searchString: target.value}))
                filterSearch(searchRes.payload)
            }
        }
    }

    const changeGameName = async (ev: React.ChangeEvent<HTMLInputElement>) => {
        const target = ev.currentTarget as HTMLInputElement;

        if (target.value.length === 50) {
            return;
        }
        
        if (target) {
            setGameName(target.value)
        }
    }

    const toggleGameLobby = (ev: MouseEvent) => {
        if (!(ev.currentTarget instanceof HTMLElement)) {
            return;
        }

        const target = ev.currentTarget as HTMLElement;
        
        if (target) {
            gameScenarios.forEach((scen: any) => {
                if (scen.id === target.dataset.id) {
                    setGameScenario(scen)
                }
            })
        }

        if (showGameLobby === '') { 
            setShowGameLobby('show-page') 
            calcGameLobbyHeight()
        } else { 
            setShowGameLobby('') 
        }
    }

    const enterPassword = (ev: React.ChangeEvent<HTMLInputElement>) => {
        setGamePassword(ev.currentTarget.value)
    }

    const openHostingModal = () => {
        setHostingModalIsOpen(true);
    }
    
    const afterOpenModal = () => {}

    const openDeleteModal = () => {
        setDeleteModalIsOpen(true);
    }
    
    const closeDeleteModal = () => {
        setDeleteModalIsOpen(false);
    }

    const openLeaveGameModal = () => {
        setLeaveGameModalIsOpen(true);
    }
    
    const closeLeaveGameModal = () => {
        setLeaveGameModalIsOpen(false);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    const openGameStartedModal = () => {
        setGameStartedModalIsOpen(true);
    }

    const closeGameStartedModal = () => {
        setGameStartedModalIsOpen(false);
    }

    const closeRejectModal = () => {
        setRejectModalIsOpen(false);
    }

    const closeHostingModal = () => {
        setHostingModalIsOpen(false);
    }

    const openAlreadyHostingModal = () => {
        setAlreadyHostingModalIsOpen(true);
    }

    const closeFailedHostModal = () => {
        setFailedHostModalIsOpen(false);
    }

    const closeAlreadyHostingModal = () => {
        setAlreadyHostingModalIsOpen(false);
    }

    const closePrivateGameModal = () => {
        setPrivateGameModalIsOpen(false);
    }

    const openErrorModal = () => {
        setErrorModalIsOpen(true);
    }

    const closeErrorModal = () => {
        setErrorModalIsOpen(false);
    }

    const getStatusLabel = (game: IGameStatus, playerIDs: string[]) => {
        if (game.host === user) {
            return <div className="scenario-item-hosting">Hosting</div>;
        } else if (playerIDs.includes(user!)) {
            if (game.started === true) {
                if(userAdmin === true) {
                    return <div className="scenario-item-hosting non-host-user-admin">In Progress</div>
                } else {
                    return <div className="scenario-item-hosting non-host">In Progress</div>
                }
            } else {
                //gameToLeave
                if (isEmpty(gameToLeave)) {
                    setGameToLeave(game.name)
                }
                if (isEmpty(gameIdToLeave)) {
                    setGameIdToLeave(game.gameId)
                }

                return <>
                        <div className="scenario-item-hosting">Joined</div>
                        <img className="game-exit" src="img/exit.jpg" data-name={game.scenarioName} data-gameid={game.gameId} onClick={leaveGameModal} alt="x"></img>
                      </>;
            }
        } else {
            return <></>
        }
    }

    const calcGameLobbyHeight = () => {
        let gameLobby = document.querySelector('.game-lobby') as HTMLElement;
        let playerHome = document.querySelector('.player-home') as HTMLElement;

        if (gameLobby !== null && playerHome !== null) {
            playerHome.style.height = gameLobby.offsetHeight + 'px'
        }
    }

    const leaveGameModal = (ev: MouseEvent) => {
        ev.stopPropagation()
        const target = ev.currentTarget as HTMLElement;
        
        if (target) {
            openLeaveGameModal()
        }
    }

    const leaveMainGame = async (ev: MouseEvent) => {
    
        if (leaveGameLoading) {
            return;
        }

        setLeaveGameLoading(true)

        let leaveGameResponse: any = await dispatch(leaveGame(gameIdToLeave))
        if (leaveGameResponse.payload.status === 500) {
            setErrorText(leaveGameResponse.payload.data);
            openErrorModal();
        } else {
            dispatch(fetchGames())
            await dispatch(fetchGameStatus(gameIdToLeave))
            closeLeaveGameModal();
            setLeaveGameLoading(false)
        }

    }

    const deleteGameModal = (ev: MouseEvent) => {
        ev.stopPropagation()
        const target = ev.currentTarget as HTMLElement;
        
        if (target) {
            setGameToDelete(target.dataset.name!)
            setGameIdToDelete(target.dataset.gameid!)
            openDeleteModal()
        }
    }

    const deleteGme = async (ev: MouseEvent) => {
        if (deleteGameLoading) {
            return;
        }
        ev.stopPropagation()
        setDeleteGameLoading(true)
        const target = ev.currentTarget as HTMLElement;
        
        if (target) {
            await dispatch(deleteGame(gameIdToDelete))
            
            dispatch(fetchGames())
            closeDeleteModal()
            setTimeout(() => {
                setIsAlreadyHostingGame(false) 
                setDeleteGameLoading(false)
            }, 1000)
        }
    }

    const getGamesList = () => {
        let gamesList: IGameStatus[] = []
        games.forEach((game: IGameStatus, i: number) => {
            if (game.completed !== true) {
                gamesList.push(game)
            }
        })
        return gamesList;
    }

    const closeStartScenarioModal = () => {
        closeHostingModal()
    }

    const startScenarioBtn = () => {
        if (passwordGood && !isEmpty(gameName) && !isAlreadyHostingGame) {
            goToHostedGame();
        } else {
            return;
        }
    }

    const onChangePassword = (isValid: any) => {
        if (!isEmpty(password)) {
            if (isValid) {
                setPasswordGood(true)
            } else {
                setPasswordGood(false)
            }
        } else {
            setPasswordGood(true)
        }
    }

    const scenNameFont = (scenName: string) => {

        if (scenName.length <= 26) {
            return '24px'
        } 
        if (scenName.length > 26 && scenName.length < 44) {
            return '18px'
        } else {
            return '15px'
        }
    }

    const gameNameFont = (scenName: string) => {
        if (scenName.length <= 14) {
            return {fontSize: '15px', marginBottom: '0', paddingTop: '0', marginTop: '-4px'}
        } else if (scenName.length > 14) {
            return {fontSize: '15px', marginBottom: '0', paddingTop: '0', marginTop: '-4px'}
        } else {
            return {};
        }
    }

    const gameScenNameFont = (scenName: string) => {
        if (scenName.length <= 14) {
            return {fontSize: '18px', marginBottom: '0', paddingTop: '2px'}
        } else if (scenName.length > 14) {
            return {fontSize: '15px', marginBottom: '0', paddingTop: '0'}
        } else {
            return {};
        }
    }

    const detailsSpacing = (scenName: string) => {
        if (scenName.length <= 14) {
            return { marginTop: '-4px' }
        } else if (scenName.length > 14) {
            return { marginTop: '-4px' }
        } else {
            return {};
        }
    }

    let itemCount = -1;

    return (
        <div className="player-main">
            <PlayerHeader showGame={showGame} intervalHandler={intervalHandler} />
            <div className={`player-home ${showGame} ${showGameLobby} ${showScenarioHideHome}`}>
                <div className={`player-feature ${showFeature}`}>
                    <img src="img/jets.png" alt="" className="feature-image" />
                    <div className="feature-content">
                        <div className="feature-title">Tabletop Exercise Platform</div>
                        <div className="feature-text">Create, Share and Experience Virtual Exercises</div>
                    </div>
                </div>
                <div className="player-sub-menu">
                    <div className="player-sub-menu-items">
                        <div className={`player-sub-menu-item ${allScenariosSelected}`} onClick={selectSubMenu}data-item="allscenarios">All Scenarios</div>
                        <div className={`player-sub-menu-item ${myScenariosSelected}`} onClick={selectSubMenu} data-item="myscenarios">My Scenarios</div>
                        <div className={`player-sub-menu-item ${featuredSelected}`} onClick={selectSubMenu} data-item="featured">Featured</div>
                        <div className={`player-sub-menu-item ${liveScenariosSelected}`} onClick={selectSubMenu} data-item="livescenarios">Live Scenarios</div>
                        <div className={`grid-layout ${gridSelected}`} onClick={selectLayout} data-item="grid">
                            <img src="img/grid-icon.svg" alt="" />
                        </div>
                        <div className={`list-layout ${listSelected}`} onClick={selectLayout} data-item="list">
                            <img src="img/list-icon.svg" alt="" />
                        </div>
                        <div className={`tag-search-content ${openSearch}`}>
                            <div className={`player-tag ${playerTagOpen}`} onClick={clickPlayerTag}>
                                <img className="player-tag-icon" alt="" src="img/player-tags.svg" />
                            </div>
                            <div className="player-search" onClick={clickPlayerSearch}>
                                <img className="player-search-icon" alt="" src="img/player-search.svg" />
                            </div>
                            <input type="text" className={`search-input ${openSearch}`} onChange={doSearch} value={searchVal} />
                        </div>
                        <button className="create-scenario-btn" onClick={() => navigate('/scenariocreator')}>Create Scenario +</button>
                    </div>
                    <div className={`player-tag-content ${playerTagOpen}`}>
                                <div className="player-tag-row">
                                    <div className="player-tag-label">Topics</div>
                                    <div className="player-tag-topics">
                                        <ReactTags
                                            tags={topicTags}
                                            delimiters={delimiters}
                                            handleDelete={handleTopicsDelete}
                                            handleAddition={handleTopicsAddition}
                                            handleDrag={handleTopicsDrag}
                                            placeholder={"Click Here to Search Tag"}
                                            inputFieldPosition="bottom"
                                            autocomplete
                                        />
                                    </div>
                                </div>
                                <div className="player-tag-row">
                                    <div className="player-tag-label">Locations</div>
                                    <div className="player-tag-locations">
                                        <ReactTags
                                            tags={locationTags}
                                            delimiters={delimiters}
                                            handleDelete={handleLocationsDelete}
                                            handleAddition={handleLocationsAddition}
                                            handleDrag={handleLocationsDrag}
                                            placeholder={"Click Here to Search Tag"}
                                            inputFieldPosition="bottom"
                                            autocomplete
                                        />
                                    </div>
                                </div>
                                <div className="player-tag-row">
                                    <div className="player-tag-label">Details</div>
                                    <div className="player-tag-details">
                                        <ReactTags
                                            tags={detailsTags}
                                            delimiters={delimiters}
                                            handleDelete={handleDetailsDelete}
                                            handleAddition={handleDetailsAddition}
                                            handleDrag={handleDetailsDrag}
                                            placeholder={"Click Here to Search Tag"}
                                            inputFieldPosition="bottom"
                                            autocomplete
                                        />
                                    </div>
                                </div>
                            </div>
                </div>
                <div className={`scenario-items ${layoutType}`}>
                <div className={`scenario-loader scenario-loader-60 ${scenarioLoader}`}></div>
                {allScenariosSelected === 'selected' ? allSearchResults.map((scenario, i) => {
                        
                        return (<div className={`scenario-item ${(i+1)%3===0 ? 'scenario-third' : ''}`} onClick={clickScenario} data-scenarioid={scenario.id} data-type="host" key={i}>
                            <img src={scenarioImages[scenario.id]?.images[0] || 'img/scenario1.png'} className="scenario-item-img" alt="" />
                            
                            <div className="scenario-item-desc">
                                <div className="scenario-item-title" style={{ fontSize: scenNameFont(scenario.name) }}>{ isEmpty(scenario.name) ? 'Unnamed Scenario' : scenario.name }</div>
                                <div className="scenario-item-details">
                                    <div className="scenario-item-player">
                                        <img src="img/people-grey.svg" alt="people" />
                                        <span>{scenario.numOfPlayers}</span>
                                    </div>
                                    <div className="scenario-item-time">
                                        <img src="img/clock-grey.svg" alt="clock" />
                                        <span>{scenario.gameTimeInterval}</span>
                                    </div>
                                    <div className="scenario-item-progress">
                                        <img src="img/progress-grey.svg" alt="progress" />
                                        <span>3</span>
                                    </div>
                                </div>
                                <div className="scenario-item-text">
                                    {scenario.description}
                                </div>
                            </div>
                        </div>)
                    }) : <></>}
                    {myScenariosSelected === 'selected' ? mySearchResults.map((scenario: IScenario, i: number) => {
                        return (<div className={`scenario-item ${(i+1)%3===0 ? 'scenario-third' : ''}`} onClick={clickScenario} data-scenarioid={scenario.id} data-type='host' key={i}>
                            <img src={scenarioImages[scenario.id]?.images[0] || 'img/scenario1.png'} className="scenario-item-img"  alt="" />
                            <div className="scenario-item-desc">
                                <div className="scenario-item-title" style={{ fontSize: scenNameFont(scenario.name) }}>{isEmpty(scenario.name) ? 'Unnamed Scenario' : scenario.name }</div>
                                <div className="scenario-item-details">
                                    <div className="scenario-item-player">
                                        <img src="img/people-grey.svg" alt="people" />
                                        <span>{scenario.numOfPlayers}</span>
                                    </div>
                                    <div className="scenario-item-time">
                                        <img src="img/clock-grey.svg" alt="clock" />
                                        <span>{scenario.gameTimeInterval}</span>
                                    </div>
                                    <div className="scenario-item-progress">
                                        <img src="img/progress-grey.svg" alt="progress" />
                                        <span>?</span>
                                    </div>
                                </div>
                                <div className="scenario-item-text">
                                    
                                </div>
                            </div>
                        </div>)
                    }) : <></>}
                    {featuredSelected === 'selected' ? featuredSearchResults.map((scenario: IScenario, i: number) => {
                    
                        return (<div className={`scenario-item ${(i+1)%3===0 ? 'scenario-third' : ''}`} onClick={clickScenario} data-scenarioid={scenario.id} data-type="host" key={i}>
                            <img src={scenarioImages[scenario.id]?.images[0] || 'img/scenario1.png'} className="scenario-item-img"  alt="" />
                            <div className="scenario-item-desc">
                                <div className="scenario-item-title" style={{ fontSize: scenNameFont(scenario.name) }}>{isEmpty(scenario.name) ? 'Unnamed Scenario' : scenario.name }</div>
                                <div className="scenario-item-details">
                                    <div className="scenario-item-player">
                                        <img src="img/people-grey.svg" alt="people" />
                                        <span>{scenario.numOfPlayers}</span>
                                    </div>
                                    <div className="scenario-item-time">
                                        <img src="img/clock-grey.svg" alt="clock" />
                                        <span>8</span>
                                    </div>
                                    <div className="scenario-item-progress">
                                        <img src="img/progress-grey.svg" alt="progress" />
                                        <span>?</span>
                                    </div>
                                </div>
                                <div className="scenario-item-text">
                                    ????
                                </div>
                            </div>
                        </div>)
                    }) : <></>}
                    {liveScenariosSelected === 'selected' ? getGamesList().map((game: IGameStatus, i: number) => {
                        let playerIDs = game.players.map((player: IPlayer) => player.userID)

                        if ((game.completed !== true && game.started === false) || (game.completed !== true && game.started === true && !isEmpty(game.players.filter((player: IPlayer) => player.userID === user)))) {
                            itemCount++
                        }

                        return ((game.completed !== true && game.started === false) || (game.completed !== true && game.started === true && !isEmpty(game.players.filter((player: IPlayer) => player.userID === user))) ? <div className={`scenario-item scenario-game-item ${joinGameLoading ? 'join-game-loading-btn' : ''}`} onClick={toggleScenarioPage} data-gameid={game.gameId} data-scenarioid={game.scenarioId} data-type='join' key={i} style={{ marginRight: (itemCount+1)%3 === 0 ? '0' : '30px' }}>
                            <div className={`join-game-loading ${joinGameLoading ? 'show' : ''}`}>
                                <div className="join-game-loading-bkg"></div>
                                <div className="join-game-loader scenario-loader-60"></div>
                            </div>
                            {game.host === user || userAdmin ? <img className="game-delete-x" src="img/grey-x.svg" data-name={game.scenarioName} data-gameid={game.gameId} onClick={deleteGameModal} alt="x"></img> : <></>}
                                {getStatusLabel(game, playerIDs)}
                                <img src={scenarioImages[game.scenarioId]?.images[0] || 'img/scenario1.png'} className="scenario-item-img"  alt="" />
                                <div className="scenario-item-desc">
                                    <div className="scenario-game-item-title" style={gameScenNameFont(game.scenarioName)}>{isEmpty(game.scenarioName) ? 'Unnamed Scenario' : game.scenarioName}</div>
                                    <div className="game-item-title" style={gameNameFont(game.scenarioName)}>({game.name})</div>
                                    <div className="scenario-item-details"  style={detailsSpacing(game.scenarioName)}>
                                        <div className="scenario-item-player">
                                            <img src="img/people-grey.svg" alt="people" />
                                            <span>{game.players.length}</span>
                                        </div>
                                        <div className="scenario-item-time">
                                            <img src="img/clock-grey.svg" alt="clock" />
                                            <span>8</span>
                                        </div>
                                        <div className="scenario-item-progress">
                                            <img src="img/progress-grey.svg" alt="progress" />
                                            <span>?</span>
                                        </div>
                                    </div>
                                    <div className="scenario-item-text">
                                        ????
                                    </div>
                                </div>
                            </div> : <div key={i} style={{ display: 'none' }}></div>)
                    }) : <></>}
                    
                </div>
            </div>
            {
                showScenarioPage === 'show' &&
                <ScenarioDescription showScenarioPage={showScenarioPage}  setShowScenarioPage={setShowScenarioPage} setShowScenarioHideHome={setShowScenarioHideHome} toggleScenarioPage={toggleScenarioPage} gameScenario={gameScenario} games={games} />
            }
            {
                showGameLobby === 'show-page' &&
                <GameLobby showGameLobby={showGameLobby} setShowGame={setShowGame} toggleGameLobby={toggleGameLobby} currentGame={currentGame} gameScenario={gameScenario} isHosting={isHosting} setIsHosting={setIsHosting} setShowGameLobby={setShowGameLobby} calcGameLobbyHeight={calcGameLobbyHeight} gamePassword={gamePassword} intervalHandler={intervalHandler} rejectModalIsOpen={rejectModalIsOpen} gameStartedModalIsOpen={gameStartedModalIsOpen} />
            }
            {
                showGame === 'show-game' &&
                <MainGame gameScenario={gameScenario} currentGameId={currentGameId} games={games} showGame={showGame} setShowGame={setShowGame} intervalHandler={intervalHandler} />
            }
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                shouldCloseOnOverlayClick={false}
                style={customSmallStyles}
                contentLabel="Example Modal"
            >
                <div className="enter-password">Enter Password</div>

                <input type="password" value={gamePassword} onChange={enterPassword} className="enter-password-input" />

                <div className={`password-error ${passwordError}`}>Password is incorrect.</div>

                <div className={`password-correct-game-started ${gameStartedError}`}>{gameStartedErrorText}</div>

                <button onClick={closeModal} className="new-cancel-btn"><span>Cancel</span></button>
                <button onClick={joinGameLocal} className={`new-confirm-btn ${joinGameLocalLoading ? 'start-loading' : ''}`} data-gameid={gameID} data-scenarioid={scenarioID}>
                    {joinGameLocalLoading ? <div className="game-save-loader-25"></div> : <></> }
                    <span>Join Now</span>
                </button>
            </Modal>

            <Modal
                isOpen={rejectModalIsOpen}
                onRequestClose={closeRejectModal}
                style={customSmallStyles}
                contentLabel="Reject Modal"
            >
                <div className="enter-password">You are not allowed to join this game.</div>

                <button onClick={closeRejectModal} className="join-game delete-cancel-btn">Close</button>
            </Modal>

            <Modal
                isOpen={gameStartedModalIsOpen}
                onRequestClose={closeGameStartedModal}
                style={customSmallStyles}
                contentLabel="Reject Modal"
            >
                <div className="enter-password">{gameStartedErrorText}</div>

                <button onClick={closeGameStartedModal} className="join-game delete-cancel-btn">Close</button>
            </Modal>

            <Modal
                isOpen={hostingModalIsOpen}
                onRequestClose={closeHostingModal}
                style={customStyles}
                contentLabel="Reject Modal"
            >

                <div className="start-scenario-header">
                    <div className="start-scenario-header-label">Start Scenario: </div>
                    <div className="start-scenario-header-name">{isEmpty(gameScenario.name) ? 'Unnamed Scenario' : gameScenario.name}</div>
                    <img src="/img/light-grey-x.svg" className="new-modal-close" alt="x" onClick={closeHostingModal}></img>
                </div>

                <div className="start-scenario-description">Make your scenario Private or Public. Private scenarios are accessible only to those with a password. Public scenarios are accessible to all.</div>

                <div className="start-scenario-content">
                    <div className="start-scenario-row">
                        {isEmpty(gameName) ? <div className="start-scenario-error">New Game Must Have a Name.</div>: <></>}
                        <div className="start-scenario-label">
                            <div className="start-scenario-title">Name</div>
                            <div className="start-scenario-text">This is the name of your hosted scenario.</div> 
                        </div>
                        <div className="start-scenario-item">
                            <input type="text" className="start-scenario-input" value={gameName} onChange={changeGameName} />
                        </div>
                    </div>
                    <div className="start-scenario-row">
                        <div className="start-scenario-label">
                            <div className="start-scenario-title">Password</div>
                            <div className="start-scenario-text">Participants must enter a  password to join the hosted scenario.</div> 
                        </div>
                        <div className="start-scenario-item password-item">
                            <input type="password" className="start-scenario-password" onChange={e => setPassword(e.target.value)} />
                            {!isEmpty(password) ? <PasswordChecklist
                                rules={["minLength","specialChar","number","capital"]}
                                minLength={5}
                                value={password}
                                onChange={onChangePassword}
                                className="scenario-password-message"
                            /> : <></>}
                        </div>
                    </div>
                    {isAlreadyHostingGame ? <div className="start-scenario-row">
                        <div className="start-scenario-label">
                            <div className="start-scenario-title">Already Hosting</div>
                            <div className="start-scenario-text">You can only host one game at a time. Would you like to delete this game?</div> 
                        </div>
                        <div className="start-scenario-item">
                            <div className="scenario-delete-game-name">
                                <span>Game: {gameToDelete}</span>
                            </div>
                            <button className={`blue-game-btn delete-game-btn ${deleteGameLoading ? 'start-loading' : ''}`} data-gameid={gameIdToDelete} onClick={deleteGme}>
                                <span>Delete Game</span>
                                {deleteGameLoading ? <div className="small-btn-loader small-btn-loader-20"></div> : <></> }
                            </button>  
                        </div>
                    </div> : <></>}
                </div>

                <button onClick={closeStartScenarioModal} className="cancel-scenario-start-btn">
                    <span>Cancel</span>
                </button>
                
                <button onClick={startScenarioBtn} className={`view-scenario-start-btn ${passwordGood && !isEmpty(gameName) && !isAlreadyHostingGame ? '' : 'disabled' } ${showHostLoading ? 'start-loading': ''}`}>
                    {showHostLoading ? <div className="game-save-loader-25"></div> : '' }
                    <span>Start Scenario</span>
                </button>
            </Modal>

            <Modal
                isOpen={failedHostModalIsOpen}
                onRequestClose={closeFailedHostModal}
                style={customStyles}
                contentLabel="Failed Host Modal"
            >
                <div className="enter-password">Initiate Hosting FAILED.  Please contact your instructor for further guidance.</div>

                <button onClick={closeFailedHostModal} className="join-game delete-cancel-btn">Close</button>
            </Modal>

            <Modal
                isOpen={alreadyHostingModalIsOpen}
                onRequestClose={closeAlreadyHostingModal}
                style={customStyles}
                contentLabel="Already Hosting Modal"
            >
                <div className="enter-password">You are already hosting a game ({alreadyHostingGame}).  You are only allowed to host one game at a time.</div>

                <button onClick={closeAlreadyHostingModal} className="join-game delete-cancel-btn">Return To Scenarios</button>
            </Modal>

            <Modal
                isOpen={privateGameModalIsOpen}
                onRequestClose={closePrivateGameModal}
                style={customStyles}
                contentLabel="Failed Host Modal"
            >
                <div className={`show-host-loading ${showHostLoading}`}>
                    <div className={`hosting-loader hosting-loader-60`}></div>
                    <div className="show-host-note">Creating Game...</div>
                </div>
                <div className="host-scenario-text">Would you like to make this scenario private?  Click "Make Private" and a password will be generated for the game.</div>
                <div className="delete-game-name"><span className="game-name-label">Game Name</span> <input name="game-name" className="game-name" value={gameName} onChange={changeGameName} /></div>
                <div className={`host-scenario-name ${showHostPassword}`}>Password: {generatedGamePassword ? generatedGamePassword : <div className="loader password-loader"></div> }</div>

                <button onClick={goToHostedGame} className="delete-cancel-btn">Make Non-Private</button>
                {generatedGamePassword ? 
                        <button className="delete-confirm-btn selected" onClick={goToHostedGame}>Go To Hosted Game</button> : <button className="delete-confirm-btn selected" onClick={makeGamePrivate}>Make Private</button>
                }
            </Modal>
            
            <Modal
                isOpen={deleteModalIsOpen}
                onRequestClose={closeDeleteModal}
                style={customSmallStyles}
                contentLabel="Delete Game Modal"
            >
                <div className="delete-game-text">Would you like to delete this game?</div>
                <div className="delete-game-name">Game: {gameToDelete}</div>

                <button onClick={closeDeleteModal} className="new-cancel-btn"><span>Cancel</span></button>
                <button onClick={deleteGme} className={`new-confirm-btn ${deleteGameLoading ? 'start-loading' : ''}`} data-gameid={gameID} data-scenarioid={scenarioID}>
                    {deleteGameLoading ? <div className="game-save-loader-25"></div> : <></> }
                    <span>Delete Game</span>
                </button>
            </Modal>

            <Modal
                isOpen={leaveGameModalIsOpen}
                onRequestClose={closeLeaveGameModal}
                style={customSmallStyles}
                contentLabel="Delete Game Modal"
            >
                <div className="new-modal-header">Leave Game? <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeLeaveGameModal}></img></div>
                
                <div className="new-modal-text">Would you like to leave this game: <span className="modal-scenario-name">{gameToLeave}</span>?</div>

                <button onClick={closeLeaveGameModal} className="new-cancel-btn"><span>Cancel</span></button>
                <button onClick={leaveMainGame} className={`new-confirm-btn ${leaveGameLoading ? 'start-loading' : ''}`} data-gameid={gameID} data-scenarioid={scenarioID}>
                    {leaveGameLoading ? <div className="game-save-loader-25"></div> : <></> }
                    <span>Leave Game</span>
                </button>
            </Modal>
            <Modal
                isOpen={errorModalIsOpen}
                onRequestClose={closeErrorModal}
                style={customStyles}
                contentLabel="Failed Host Modal"
            >
                <div className="enter-password">{errorText}</div>

                <button onClick={closeErrorModal} className="join-game delete-cancel-btn">Close</button>
            </Modal>
        </div>
    )
}
 
export default PlayerHome